import { type EditorView } from 'prosemirror-view'
import { isPlatformApple } from './platformSniffing'

export function patchEditorFlushForSafari(editorView: EditorView) {
  // Hack to prevent Safari infinite <br class="ProseMirror-trailingBreak"> loop
  // https://github.com/ProseMirror/prosemirror/issues/1271
  if (isPlatformApple()) {
    const domObserver = (editorView as any).domObserver
    const domObserverFlush = domObserver.flush.bind(domObserver)
    domObserver.flush = () => setTimeout(domObserverFlush, 1)
  }
}
